import { Attributes, LookupBase } from '@singularsystems/neo-core';
import Contact from './Contact';

export default class ContactLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public contactId: number = 0;

    @Attributes.Nullable()
    public contactTypeId: number | null = null;

    @Attributes.Nullable()
    public titleId: number | null = null;

    public firstName: string = "";

    public lastName: string = "";

    public emailAddress: string = "";

    public phoneNo: string = "";

    // Client only properties / methods

    @Attributes.DisplayMember()
    public get fullName() {
        return `${this.firstName} ${this.lastName}`;
    }

    public toString() {
        return this.fullName;
    }

    public static fromContact(contact: Contact): ContactLookup {
        const lookup = new ContactLookup();
        lookup.contactId = contact.contactId;
        lookup.contactTypeId = contact.contactTypeId;
        lookup.titleId = contact.values.titleId;
        lookup.firstName = contact.values.firstName;
        lookup.lastName = contact.values.lastName;
        lookup.emailAddress = contact.values.emailAddress;
        lookup.phoneNo = contact.values.phoneNo;
        return lookup
    }
}